
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/membership/registration",
      function () {
        return require("private-next-pages/membership/registration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/membership/registration"])
      });
    }
  